import * as RequestStatusTypes from '../../constants/RequestStatusTypes';
export default function requestStatusFactory(actionType) {
  return function requestStatusReducer(state = RequestStatusTypes.UNINITIALIZED, action) {
    switch (action.type) {
      case actionType:
        return action.requestStatus;
      default:
        return state;
    }
  };
}